"use client";

import ProgrammePostsFallback from "./ProgrammePostsFallback";

export default function MandarinPostsFallback({
  heading,
  links,
}: {
  heading?: string | null;
  links: readonly { href: string; title: string }[];
}) {
  return (
    <ProgrammePostsFallback
      heading={heading}
      links={links}
      languageNotice="以下文章目前提供英文内容。"
      linkLanguage="en"
    />
  );
}
